import { FunctionComponent } from "react";

type TProps = {
  selected?: string;
  placeholder: string;
  onChange: (value: string) => void;
  options: string[];
};

const Select: FunctionComponent<TProps> = (props) => (
  <select
    value={props.selected}
    onChange={(event) => props.onChange(event.target.value)}
  >
    <option value="select" disabled>
      {props.placeholder}
    </option>

    {props.options.map((option) => (
      <option key={option} value={option}>
        {option}
      </option>
    ))}
  </select>
);

export default Select;
